import './App.css';
import MarginCalculator from './components/MarginCalculator';

const App = () => {
  return (
    <div className="App">
      <>
        <MarginCalculator />
      </>
    </div>
  );
}

export default App;
